var _clipPath, _circle, _clipPath2, _circle2, _clipPath3, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBymmyLoadingScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_0",
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      maxWidth: "auto",
      stroke: "transparent"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    style: {
      maxWidth: "auto",
      stroke: "transparent"
    },
    viewBox: "0 0 1920 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props)), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "sweep3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 350,
    height: 350
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 200 200",
    to: "360 200 200",
    dur: "5s",
    repeatCount: "indefinite"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 160,
    fill: "none",
    stroke: "#28a8e2",
    strokeWidth: 2,
    fillOpacity: 0.5,
    clipPath: "url(#sweep3)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    values: "0;0.5;0",
    dur: "3s",
    repeatCount: "indefinite"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "sweep2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 320,
    height: 320
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 200 200",
    to: "360 200 200",
    dur: "3s",
    repeatCount: "indefinite"
  })))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 140,
    fill: "none",
    stroke: "#28a8e2",
    strokeWidth: 2,
    fillOpacity: 0.5,
    clipPath: "url(#sweep2)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    values: "0;0.5;0",
    dur: "3s",
    repeatCount: "indefinite"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "sweep1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 320,
    height: 320
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 200 200",
    to: "360 200 200",
    dur: "2s",
    repeatCount: "indefinite"
  })))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 120,
    fill: "none",
    stroke: "#28a8e2",
    strokeWidth: 2,
    fillOpacity: 0.5,
    clipPath: "url(#sweep1)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    values: "0;0.5;0",
    dur: "1s",
    repeatCount: "indefinite"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBymmyLoadingScreen);
export default __webpack_public_path__ + "static/media/BymmyLoadingScreen.fb7b26e37b3c9316d5c18981062f4704.svg";
export { ForwardRef as ReactComponent };